import { ResponsiveImage } from '@sleepstation/components'
import { mq } from '@sleepstation/style-api-helpers'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  > * {
    width: 100%;
    margin: 0 auto;
  }
`

const SmallImageWrapper = styled.div`
  max-width: ${rem(419)};

  ${mq(`mediumUp`)} {
    display: none;
  }
`

const LargeImageWrapper = styled.div`
  display: none;

  ${mq(`mediumUp`)} {
    display: block;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalProductShot = ({ image, imageLarge }) => (
  <Layout>
    <SmallImageWrapper>
      <ResponsiveImage src={image.url} alt={image.alt} />
    </SmallImageWrapper>
    <LargeImageWrapper>
      <ResponsiveImage src={imageLarge.url} alt={image.alt} />
    </LargeImageWrapper>
  </Layout>
)

PortalProductShot.propTypes = {
  image: PropTypes.object.isRequired,
  imageLarge: PropTypes.object.isRequired,
}

PortalProductShot.defaultProps = {}

export default PortalProductShot
